import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyDhhtsQSdnrP2Zyx3miKY5DqalXtM3b5Zw",
    authDomain: "rekber-dev.firebaseapp.com",
    projectId: "rekber-dev",
    storageBucket: "rekber-dev.firebasestorage.app",
    messagingSenderId: "707398369849",
    appId: "1:707398369849:web:eed1650236df1d8d3e43e8",
    measurementId: "G-4E075CEBE2"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const analytics = getAnalytics(app);
const provider = new GoogleAuthProvider();

export { auth, provider, analytics };
